import { ArsTableState, ArstActionContextmenuAction } from "../interface";
import { arst_toggleSpaceAfter } from "./arst_toggleSpaceAfter";

/**
 * Toggles the "Space after each sub-group" (`spaceAfterSubGroups`) setting for the row grouping
 * factor targeted by a context-menu action, adding a blank row after each group or data value.
 *
 * @param state - Current ARS table state
 * @param action - Context-menu action identifying the selected grouping factor or group label
 * @returns Updated ARS table state
 */
export const arst_toggleSpaceAfterSubGroups = <T>(
  state: ArsTableState<T>,
  action: ArstActionContextmenuAction<T>,
): ArsTableState<T> => arst_toggleSpaceAfter(state, action, "spaceAfterSubGroups");
